module.exports = __webpack_public_path__ + "img/10.637e42a2.png";